Function.prototype.clone = function() {
  const cloneTarget = Symbol.for('cloneTarget');
  const targetFn = this[cloneTarget] ?? this;

  function clone() {
    return targetFn.apply(this, arguments);
  };

  for (const key in targetFn) {
    clone[key] = this[key];
  }

  clone[cloneTarget] = targetFn;

  return clone;
};

class PDPMultipleVariants extends HTMLElement {
  NAME = 'PDPMultipleVariants'

  constructor() {
    super();
    console.info(`${this.NAME} > constructor`);
    this.map = new Map();
    this.openCartEl = document.querySelector('modal-open[target="cart-drawer"]');
  }

  connectedCallback() {
    console.info(`${this.NAME} > connectedCallback`);
    //
    const mutationCallback = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList' && Array.from(mutation.removedNodes).includes(this.variantSelector)) {
          console.info('removed product-variant-selector');
          this.addListeners();
        }
      }
    }
    //
    this.addListeners();
    this.observer = new MutationObserver(mutationCallback);
    this.observer.observe(this, { attributes: false, childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.cleanup(true);
  }

  cleanup(disconnect = false) {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
    if (disconnect && this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  addListeners() {
    this.cleanup();
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    const vs = this.querySelector('product-variant-selector');
    const atcBtn = document.querySelector('product-to-cart button[data-element="to-cart-button"]');
    //
    this.addtoCartBtn = atcBtn.cloneNode(true);
    this.addtoCartBtn.setAttribute('type', 'button');
    atcBtn.replaceWith(this.addtoCartBtn);
    this.addtoCartBtn.addEventListener('click', () => this.addtoCart(), { signal });
    /* console.log(this.addtoCartBtn); */
    //
    if (vs._onVariantChange) {
      this.variantSelector = vs.cloneNode(true);
      this.variantSelector.__onVariantChange = vs._onVariantChange.clone();
    } else {
      this.variantSelector = vs;
    }
    //
    this.variantSelector.addEventListener('change', (e) => {
      e.stopImmediatePropagation();
      if (e.target.type === 'radio') {
        this.variantSelector._onVariantChange(e);
      }
      /* console.log(e.target.type, e); */
    },  { signal });
    //
    if (vs._onVariantChange) vs.replaceWith(this.variantSelector);
    //
    this.checkboxes = Array.from(this.variantSelector.querySelectorAll('input[type="checkbox"]'));
    this.numberBtnInputs = Array.from(this.variantSelector.querySelectorAll('number-button input'));
    this.updateMap();
    //
    this.checkboxes.forEach(input => {
      input.addEventListener('input', (e) => this.onCheckbox(e), { signal });
    });
    //
    this.numberBtnInputs.forEach(input => {
      input.addEventListener('input', (e) => this.onNumberBtnInput(e), { signal });
    })
  }

  onCheckbox(e) {
    console.info(`${this.NAME} > onCheckbox > ${e.target.value} > checked:${e.target.checked}`);
    if (e.target.checked) {
      this.map.set(e.target.value, { id: e.target.dataset.variantId, quantity: 1 });
    } else {
      this.map.delete(e.target.value);
      const input = this.numberBtnInputs.find(el => el.dataset.productVariant === e.target.dataset.variantId);
      input.value = 1;
    }
    /* this.viewMap(); */
  }

  onNumberBtnInput(e) {
    console.info(`${this.NAME} > onNumberBtnInput > ${e.target.dataset.productVariant} > value:${e.target.valueAsNumber}`);
    if (e.target.valueAsNumber === 0) {
      this.map.delete(e.target.dataset.name);
      const input = this.checkboxes.find(el => el.dataset.variantId === e.target.dataset.productVariant);
      input.checked = false;
      e.target.value = 1;
    } else {
      this.map.set(e.target.dataset.name, { id: e.target.dataset.productVariant, quantity: e.target.valueAsNumber});
    }
    /* this.viewMap(); */
  }

  updateMap() {
    let nb, ni;
    this.map.forEach(({id, quantity}, key) => {
      const input = this.checkboxes.find(el => el.value === key);
      if (input) {
        input.checked = true;
        nb = input.parentElement.nextElementSibling;
        if (nb) nb.dataset.value = quantity;
        /* console.log(nb); */
      }
    });
    this.map.clear();
    this.checkboxes.filter(input => input.checked).map(input => ({id: input.dataset.variantId, value: input.value })).forEach(({id, value}) => {
      ni = this.numberBtnInputs.find(el => el.dataset.productVariant === id);
      if (ni) this.map.set(value, { id, quantity: ni.valueAsNumber})
      /* console.log(ni); */
    });
    /* this.viewMap(); */
  }

  viewMap() {
    this.map.forEach((value, key) => {
      console.info(`map[${key}] =`, value);
    });
  }

  buildCartData() {
    if (!this.map.size) return;
    const propInputs = document.querySelectorAll('form[action="/cart/add"] input[name^="properties"]:not(:disabled)');
    const formData = { items: [] };
    const properties = {};
    let name;
    propInputs.forEach(input => {
      name = input.name.split('properties[')[1].split(']')[0];
      properties[name] = input.value === '' ? undefined : input.value;
    });
    //
    this.map.forEach(({id, quantity}, key) => {
      formData.items.push({ id, quantity, properties });
    });
    console.info(`${this.NAME} > buildCartData >`, formData);
    return formData;
  }

  addtoCart() {
    console.info(`${this.NAME} > addtoCart`);
    const data = this.buildCartData();
    const cartProvider = document.querySelector('cart-provider');
    cartProvider._addToCart(data);
  }

}

customElements.define('pdp-multiple-variants', PDPMultipleVariants);